import { Box, useTheme, Typography, Button } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import ExoAvatar from '../../../components/exo/ExoAvatar';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ProjectListItem = ({ project }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const name = !project.clientType
    ? t('internal')
    : project.clientType === 'company'
    ? project.client?.name
    : `${project.client?.lastName || ''} ${project.client?.firstName || ''}`;

  const { nr, externalNr, clientType, client, image } = project || {};

  return (
    <Button
      component={NavLink}
      to={`/projects/management/${project.id}`}
      variant="contained"
      color="secondary"
      sx={{
        padding: '8px 12px',
        justifyContent: 'flex-start',
        textTransform: 'none',
      }}
      className="w-full flex flex-row items-center gap-3 backdrop-blur-lg rounded-lg"
    >
      {image ? (
        <img
          src={image.temporaryUrl}
          className="h-10 w-10 rounded-[5px] object-cover shrink-0"
        />
      ) : (
        <ExoAvatar
          picture={client?.logo?.temporaryUrl}
          type={clientType}
          name={name}
          size="40px"
        />
      )}
      <Typography variant="h5" className="monospace opacity-50 shrink-0">
        {nr}
      </Typography>
      <Box className="flex flex-col items-start grow min-w-0">
        <Typography
          variant="h5"
          sx={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            textAlign: 'left',
          }}
        >
          <b>{project.name}</b>
        </Typography>
        <Typography variant="h6" className="opacity-80">
          {name}
        </Typography>
      </Box>
      <Typography variant="h5" className="monospace opacity-50 shrink-0">
        {externalNr}
      </Typography>
    </Button>
  );
};
